import { PropTypes } from "prop-types";
import { useMemo } from "react";
import { connectSearchBox } from "react-instantsearch-dom";

import { useLocalizedSentenceDict } from "../../../../hooks/useSentenceDict";

import Categories from "./Categories";
import SearchCards from "./topSearches/SearchCards";
import SearchLinks from "./topSearches/SearchLinks";
import { Link } from "../../../al_components/ALLink";

import * as Styles from "./topSearches/styles.module.scss";

const searchMappings = [
  { search: "al luxe", name: "Meet AL Luxe", link: "/welcome-to-ana-luisa-luxe/" },
  { search: "luxe", name: "Meet AL Luxe", link: "/welcome-to-ana-luisa-luxe/" },
  { search: "membership", name: "Meet AL Luxe", link: "/welcome-to-ana-luisa-luxe/" },
  { search: "subscription", name: "Meet AL Luxe", link: "/welcome-to-ana-luisa-luxe/" },
  {
    search: "al luxe",
    name: "FAQs",
    link: "https://faq.analuisa.com/categories/al-luxe-SJJkS8IaT",
  },
  { search: "luxe", name: "FAQs", link: "https://faq.analuisa.com/categories/al-luxe-SJJkS8IaT" },
  {
    search: "membership",
    name: "FAQs",
    link: "https://faq.analuisa.com/categories/al-luxe-SJJkS8IaT",
  },
  {
    search: "subscription",
    name: "FAQs",
    link: "https://faq.analuisa.com/categories/al-luxe-SJJkS8IaT",
  },
  {
    search: "cancel membership",
    name: "FAQs",
    link: "https://faq.analuisa.com/categories/al-luxe-SJJkS8IaT",
  },
  {
    search: "pause membership",
    name: "FAQs",
    link: "https://faq.analuisa.com/categories/al-luxe-SJJkS8IaT",
  },
  {
    search: "skip membership",
    name: "FAQs",
    link: "https://faq.analuisa.com/categories/al-luxe-SJJkS8IaT",
  },
  { search: "cancel membership", name: "Manage my membership", link: "/ana-luisa-luxe/" },
  { search: "pause membership", name: "Manage my membership", link: "/ana-luisa-luxe/" },
  { search: "skip membership", name: "Manage my membership", link: "/ana-luisa-luxe/" },
  { search: "track", name: "Track my order", link: "/track-my-order/" },
  { search: "track my order", name: "Track my order", link: "/track-my-order/" },
  {
    search: "where is my order",
    name: "Track my order",
    link: "/track-my-order/",
  },
  {
    search: "warranty",
    name: "Warranty",
    link: "https://faq.analuisa.com/en_us/search?q=warranty",
  },
  {
    search: "permanent",
    name: "Permanent Jewelry",
    link: "/permanent-jewelry/",
  },
  {
    search: "return",
    name: "Returns",
    link: "https://faq.analuisa.com/categories/exchanges-returns-BJh2hrnxc",
  },
  {
    search: "exchange",
    name: "Exchanges",
    link: "https://faq.analuisa.com/categories/exchanges-returns-BJh2hrnxc",
  },
  {
    search: "shipping",
    name: "Shipping",
    link: "https://faq.analuisa.com/categories/shipping-Byoh3Bng9",
  },
  {
    search: "gift card",
    name: "Gift Card",
    link: "https://faq.analuisa.com/categories/payment-gift-cards-SkK33Bhlq",
  },
];

function TopSearches({
  refine,
  searchQuery = null,
  topCategories,
  cards,
  nbHits,
  currentRefinement,
  links,
}) {
  const dict = useLocalizedSentenceDict();

  const lookingFor = useMemo(() => {
    if (!searchQuery) return [];
    const seen = new Set();
    return searchMappings
      .filter((item) => {
        const itemSearch = item.search.toLowerCase();
        const query = searchQuery.toLowerCase();
        return itemSearch.includes(query) || query.includes(itemSearch);
      })
      .map((item) => ({ name: item.name, link: item.link }))
      .filter((item) => {
        if (seen.has(item.link)) return false;
        seen.add(item.link);
        return true;
      });
  }, [searchQuery]);

  const lookingForElement = useMemo(
    () =>
      lookingFor &&
      lookingFor.length > 0 && (
        <div className={Styles.topSearches__lookingFor}>
          <h3 className="h3 h3--bold">{dict.get("Are you looking for:")}</h3>
          {lookingFor.map((item) => (
            <Link
              key={`looking_for_search_${item.link}`}
              to={item.link}
              className="underline subtext"
            >
              {item.name}
            </Link>
          ))}
        </div>
      ),

    [lookingFor, dict]
  );

  if (currentRefinement && nbHits > 0) {
    if (lookingFor && lookingFor.length > 0) {
      return (
        <div className={Styles.topSearches}>
          <div className={`${Styles.topSearches__container} `}>{lookingForElement}</div>
        </div>
      );
    }
    return null;
  }

  return (
    <div className={Styles.topSearches}>
      <div className={`${Styles.topSearches__container} `}>
        {lookingForElement}

        {nbHits === 0 && !links && lookingFor.length === 0 && (
          <div>
            <h3 className={`h3 h3--bold h3--uc ${Styles.topSearches__title}`}>
              {dict.get("No matches found")}
            </h3>
            <p className="subtext">
              {dict.get(
                "Try another search or maybe we can interest you with these popular search terms:"
              )}
            </p>
          </div>
        )}

        <Categories
          refine={refine}
          categories={topCategories}
          currentRefinement={currentRefinement}
          nbLinks={links?.length || 0}
        />
        <SearchLinks links={links} nbHits={nbHits} currentRefinement={currentRefinement} />
      </div>
      {nbHits > 0 && cards && cards.length > 0 && <SearchCards cards={cards} />}
    </div>
  );
}

TopSearches.propTypes = {
  refine: PropTypes.func,
  topCategories: PropTypes.arrayOf(PropTypes.string),
  searchQuery: PropTypes.string,
  cards: PropTypes.arrayOf(PropTypes.shape({})),
  nbHits: PropTypes.number,
  currentRefinement: PropTypes.string,
  links: PropTypes.arrayOf(PropTypes.shape({})),
};

export default connectSearchBox(TopSearches);
